import { fetch } from '@biscuits/graphql';
import { createContext } from 'react';
import * as CONFIG from './config.js';
const FOUR_HOURS = 4 * 60 * 60 * 1000;
const FIFTEEN_SECONDS = 15 * 1000;
export function getVerdantSync({ appId, initialPresence, access, dashboardMode, }) {
    return {
        initialPresence,
        defaultProfile: {
            id: '',
            name: 'Anonymous',
            imageUrl: null,
        },
        authEndpoint: `${CONFIG.API_ORIGIN}/verdant/token/${appId}?access=${access}`,
        useBroadcastChannel: true,
        fetch,
        pullInterval: dashboardMode ? FOUR_HOURS : FIFTEEN_SECONDS,
    };
}
export const VerdantContext = createContext(null);
//# sourceMappingURL=verdant.js.map